<template>
  <div>
  <HomeAltLayout isHome="true" bg_icon='fyiio'>
            <FyiioSvgLogo />
            <div class="row register-form smallzer">
              <div class="center col s12 m4 offset-m6">
                  <h2 style="color:white;font-size:36px">Resend confirmation code</h2>
                  <p style="color:white;font-size:25px">
                    Enter your email below and we'll resend your confirmation code.
                  </p>
                  <div class="alert alert-danger" v-if="error">
                    <p v-if="error" class="error">{{ error.message }}</p>
                  </div>

                </div>
          </div>
            
            <form @submit.prevent="confirm">
              <div class="row register-form smallzer">
                  <div class="center col s12 m4 offset-m6 " style="background-color:white;border-radius:5px">
                      <div class="input-field" style="height:30px">
                          <input id="email_inline" type="text"  class="fiedler form-control"  v-model="username" required style="background:white">
                          <label for="email_inline" class="adjust-label">Email address</label>
                      </div>
                  </div>
              </div>
              <br>
              <div class="row register-form smallzer">
                  <div class="col s12 offset-m6 " :class="$mq === 'md'?'left':'center'">
                    <button class="btn blue" :style="$mq === 'md'?'position:relative; left:-10px':''" style="border-radius:20px">resend code</button>
                  </div>
                </div>
              <!-- <p>didn't get your code?</p>
              <a href="#">send another one</a> -->
            </form> 
          
  </HomeAltLayout>
  </div>
</template>

<script>
import HomeAltLayout from '@/containers/layouts/HomeAltLayout'
import FyiioSvgLogo from '@/components/FyiioSvgLogo'
export default {
  data () {
    return {
      username: this.$route.query.username,
      error: null
    }
  },
  methods: {
    confirm () {
      this.$cognitoAuth.resendCode(this.username, this.code, (err, result) => {
        if (err) {
          this.error = err
          console.error(err)
        } else {
          this.$router.replace('/confirm?username='+this.username)
        }
      })
    }
  },
  components: {
    HomeAltLayout,
    FyiioSvgLogo
  }
}
</script>

<style scoped>
.bg-icon {
  color: red;
}
.mobileLayout {
  background-image: url('./../../assets/galaxy.png');
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/containers/authentication/ResendAlt.vue